const genderLabels: Record<string, string> = {
  0: '未知的性别',
  1: '男性',
  2: '女性',
  9: '未说明的性别',
};

export function genderLabel(value?: string | null) {
  if (!value) return '未知';
  return genderLabels[value] ?? value;
}
